import styled, { keyframes, css } from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	display: flex;
	height: 100%;
`;

const fadeAnimation = keyframes`
 	0% { opacity: 0; }
 	100% { opacity: 1; }
`;

export const FixedHeader = styled.div`
	position: fixed;
	z-index: 2;
	background-color: white;
	width: 100%;
	animation: ${fadeAnimation} 0.3s ease;
	display: flex;
	align-items: center;
	height: 48px;
	margin-left: -32px;
	padding-left: 32px;
`;

export const OrderedItemWrapper = styled.div`
	display: flex;
	justify-content: center;
	width: 100%;

	${({ order }) =>
		order &&
		css`
			order: ${order};
		`};
`;

export const SectionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	background-color: ${colors.white};
	box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
	padding: 2%;
`;

export const KpiGridContainer = styled.div`
	display: grid;
	padding: 20px;
	grid-template-columns: repeat(5, 1fr);
	height: 70%;
	gap: 10px;
`;

export const KpiWrapper = styled.div`
	width: 14%;
	padding: 1em;
	margin: 0.5%;
	background-color: ${colors.white};
	box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
`;

export const LoadingWrapper = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
`;

export const HeaderForFilter = styled.div`
	font-size: 17px;
	font-weight: 500;
	letter-spacing: 0.3px;
	cursor: pointer;
	color: ${colors.grey6};

	&:hover {
		color: ${colors.green2};
	}

	& + &:before {
		padding: 8px 3px 8px 5px;
		content: '/';
	}

	&:last-child {
		cursor: default;
		color: ${colors.grey8};

		&:hover {
			color: ${colors.grey8};
		}
	}

	${({ isLarge }) => isLarge && 'font-size: 19px;'};
`;

export const ScrollContainer = styled.div`
  width:120%;
  height: 100%;
  overflow-y: scroll;
  background-color: ${colors.grey1},
  /* overflow: scroll; */
  
  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  &::-webkit-scrollbar-track {
    /* background: #f1f1f1; */
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;
export const CardValue = styled.div`
	display: block;
	font-size: 150%;
	font-weight: bolder;
`;

// Styled component for the .card-text class
export const CardText = styled.div`
	display: block;
	font-size: 70%;
	padding-left: 0.2em;
`;
